import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user: {
            account: window.localStorage.getItem("_user") == null ? '' :
                JSON.parse(window.localStorage.getItem("_user")).account,
            token: window.localStorage.getItem("_user") == null ? '' :
                JSON.parse(window.localStorage.getItem("_user")).token,
            roles: window.localStorage.getItem("_user") == null ? '' :
                JSON.parse(window.localStorage.getItem("_user")).roles,
            permissions: window.localStorage.getItem("_user") == null ? '' :
                JSON.parse(window.localStorage.getItem("_user")).permissions,
            menus: window.localStorage.getItem("_user") == null ? '' :
                JSON.parse(window.localStorage.getItem("_user")).menus
        },
        ruleConfig: {
            selectedStyleIndex: window.localStorage.getItem("_user_selectedStyleIndex") == null ? "0" :
                JSON.parse(window.localStorage.getItem("_user_selectedStyleIndex"))
        },
        taskConst: {
            selectedActivityType: window.localStorage.getItem("_task_selectedActivityType") == null ? "0" :
                JSON.parse(window.localStorage.getItem("_task_selectedActivityType"))
        },

        newProjectVersion: {
            selectedVersion: window.localStorage.getItem("_selectVersion") == null ? "1.0.0" :
                JSON.parse(window.localStorage.getItem("_selectVersion")),
            selectedAppType: window.localStorage.getItem("_selectAppType") == undefined || window.localStorage.getItem("_selectAppType") == null ? "1" :window.localStorage.getItem("_selectAppType"),
            selectedTaskType: window.localStorage.getItem("_selectTaskType") == null ? "1" :
                JSON.parse(window.localStorage.getItem("_selectTaskType")),
            selectedRechargeType: window.localStorage.getItem("_selectRechargeType") == null ? "1" :
                JSON.parse(window.localStorage.getItem("_selectRechargeType")),
        },

        adMaterial: {
            selectedPositionIndex: window.localStorage.getItem("_material_selectedPositionIndex") == null ? "0" :
                JSON.parse(window.localStorage.getItem("_material_selectedPositionIndex"))
        },
        exchangeRule: {
            id: window.localStorage.getItem("_pageExchange") == null ? '' :
                JSON.parse(window.localStorage.getItem("_pageExchange")).id,
            name: window.localStorage.getItem("_pageExchange") == null ? '' :
                JSON.parse(window.localStorage.getItem("_pageExchange")).name,
            state: window.localStorage.getItem("_pageExchange") == null ? '' :
                JSON.parse(window.localStorage.getItem("_pageExchange")).state,
        },
        dailyActivity: {
            id: window.localStorage.getItem("_pageActivity") == null ? '' :
                JSON.parse(window.localStorage.getItem("_pageActivity")).id,
            name: window.localStorage.getItem("_pageActivity") == null ? '' :
                JSON.parse(window.localStorage.getItem("_pageActivity")).name,
            prizeList: window.localStorage.getItem("_pageActivity") == null ? '' :
                JSON.parse(window.localStorage.getItem("_pageActivity")).prizeList,
        },
        prizeId: window.localStorage.getItem("_prizeId") == null ? '' :
            JSON.parse(window.localStorage.getItem("_prizeId")),
        loginFlag: {
            selectedLoginFlag: window.localStorage.getItem("_login_401_flag") == null ? 0 : window.localStorage.getItem("_login_401_flag")
        },
        key: window.localStorage.getItem("_key") == null ? '' :
            JSON.parse(window.localStorage.getItem("_key")),
        position: {
            id: window.localStorage.getItem("_position") == null ? '' :
                JSON.parse(window.localStorage.getItem("_position")).id,
            name: window.localStorage.getItem("_position") == null ? '' :
                JSON.parse(window.localStorage.getItem("_position")).name,
            state: window.localStorage.getItem("_position") == null ? '' :
                JSON.parse(window.localStorage.getItem("_position")).state,
        },
        block: {
            id: window.localStorage.getItem("_block") == null ? '' :
                JSON.parse(window.localStorage.getItem("_block")).id,
            name: window.localStorage.getItem("_block") == null ? '' :
                JSON.parse(window.localStorage.getItem("_block")).name,
            type: window.localStorage.getItem("_block") == null ? '' :
                JSON.parse(window.localStorage.getItem("_block")).type,
        },
        secondBlock: {
            id: window.localStorage.getItem("_secondBlock") == null ? '' :
                JSON.parse(window.localStorage.getItem("_secondBlock")).id,
            name: window.localStorage.getItem("_secondBlock") == null ? '' :
                JSON.parse(window.localStorage.getItem("_secondBlock")).name,
            type: window.localStorage.getItem("_secondBlock") == null ? '' :
                JSON.parse(window.localStorage.getItem("_secondBlock")).type,
        },
        category: {
            id: window.localStorage.getItem("_category") == null ? '' :
                JSON.parse(window.localStorage.getItem("_category")).id,
            name: window.localStorage.getItem("_category") == null ? '' :
                JSON.parse(window.localStorage.getItem("_category")).name,
        },
        liveActivity: {
            id: window.localStorage.getItem("_liveActivity") == null ? '' :
                JSON.parse(window.localStorage.getItem("_liveActivity")).id,
            name: window.localStorage.getItem("_liveActivity") == null ? '' :
                JSON.parse(window.localStorage.getItem("_liveActivity")).name,
        },
        secondLiveActivity: {
            id: window.localStorage.getItem("_secondLiveActivity") == null ? '' :
                JSON.parse(window.localStorage.getItem("_secondLiveActivity")).id,
            name: window.localStorage.getItem("_secondLiveActivity") == null ? '' :
                JSON.parse(window.localStorage.getItem("_secondLiveActivity")).name,
        }
    },
    mutations: {
        login(state, user) {
            state.user = user
            window.localStorage.setItem('_user', JSON.stringify(user))
        },
        changeSelectedStyleIndex(state, _index) {
            state.ruleConfig.selectedStyleIndex = _index
            window.localStorage.setItem("_user_selectedStyleIndex", _index)
        },
        changeSelectedPositionIndex(state, _index) {
            state.adMaterial.selectedPositionIndex = _index
            window.localStorage.setItem("_material_selectedPositionIndex", _index)
        },
        changeSelectedActivityType(state, _index) {
            state.taskConst.selectedActivityType = _index
            window.localStorage.setItem("_task_selectedActivityType", _index)
        },
        changeSelectedVersionType(state, _index) {
            state.newProjectVersion.selectedVersion = _index
            window.localStorage.setItem("_selectVersion", JSON.stringify(_index))
        },
        changeSelectedAppTypeType(state, _index) {
            state.newProjectVersion.selectedAppType = _index
            window.localStorage.setItem("_selectAppType", _index)
        },
        changeSelectedTaskType(state, _index) {
            state.newProjectVersion.selectedTaskType = _index
            window.localStorage.setItem("_selectTaskType", JSON.stringify(_index))
        },
        changeSelectedRechargeType(state, _index) {
            state.newProjectVersion.selectedRechargeType = _index
            window.localStorage.setItem("_selectRechargeType", JSON.stringify(_index))
        },
        jump(state, dailyActivity) {
            state.dailyActivity = dailyActivity;
            window.localStorage.setItem("_pageActivity", JSON.stringify(dailyActivity))
        },
        exchange(state, exchangeRule) {
            state.exchangeRule = exchangeRule;
            window.localStorage.setItem("_pageExchange", JSON.stringify(exchangeRule))
        },
        config(state, prizeId) {
            state.prizeId = prizeId;
            window.localStorage.setItem("_prizeId", prizeId)
        },
        changeLoginFlag(state, flag) {
            state.loginFlag.selectedLoginFlag = flag;
            window.localStorage.setItem("_login_401_flag", flag)
        },
        position(state, position) {
            state.position = position;
            window.localStorage.setItem("_position", JSON.stringify(position))
        },
        addBlock(state, block) {
            state.block = block;
            window.localStorage.setItem("_block", JSON.stringify(block))
        },
        addSecondBlock(state, secondBlock) {
            state.secondBlock = secondBlock;
            window.localStorage.setItem("_secondBlock", JSON.stringify(secondBlock))
        },
        addCategory(state, category) {
            state.category = category;
            window.localStorage.setItem("_category", JSON.stringify(category))
        },
        addLiveActivity(state, liveActivity) {
            state.liveActivity = liveActivity;
            window.localStorage.setItem("_liveActivity", JSON.stringify(liveActivity))
        },
        addSecondLiveActivity(state, secondLiveActivity) {
            state.secondLiveActivity = secondLiveActivity;
            window.localStorage.setItem("_secondLiveActivity", JSON.stringify(secondLiveActivity))
        },
        addKey(state, key) {
            state.key = key;
            window.localStorage.setItem("_key", JSON.stringify(key))
        },       
        

    }
})
